import { logoSrc } from '../../images';
import styles from './Logo.module.scss';

const Logo = () => {
	return <img className={styles.logo} src={logoSrc} alt="Collab.Land" />;
};

export default Logo;
